// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/UnileverShilling.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Unilever Shilling";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal; }

* {
  margin: 0; }

.Header_headerLogo__xZ0F4 {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 16px 0; }
  .Header_headerLogo__xZ0F4 img {
    width: 48px;
    height: 48px; }
  .Header_headerLogo__xZ0F4 p {
    font-weight: 600;
    font-size: 24px;
    color: #FFFFFF;
    padding-top: 8px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_headerLogo__xZ0F4 {
      display: none; } }

.Header_details__2H5g0, .Header_dropDown__6bSwA {
  display: none;
  font-size: 14px;
  padding-top: 2px;
  padding-left: 350px; }
  .Header_details__2H5g0 p, .Header_dropDown__6bSwA p {
    font-weight: 14px; }
    .Header_details__2H5g0 p span, .Header_dropDown__6bSwA p span {
      font-weight: 600; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_details__2H5g0, .Header_dropDown__6bSwA {
      display: none;
      padding-left: 0px;
      flex-direction: column;
      align-items: end;
      text-align: end;
      padding-top: 30px;
      height: 0px; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_dropDown__6bSwA {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0;
    height: 60px;
    padding-top: 8px; } }

.Header_detailsRole__o4gqo {
  padding-right: 8px;
  border-right: 1px solid; }
  .Header_detailsRole__o4gqo b {
    padding-left: 6px;
    font-size: 14px;
    font-weight: 400; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_detailsRole__o4gqo {
      border: none;
      padding: 0; } }

.Header_assignment__sOzLF {
  padding-left: 8px; }
  .Header_assignment__sOzLF span {
    padding-right: 6px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_assignment__sOzLF {
      display: flex;
      flex-direction: row; }
      .Header_assignment__sOzLF span {
        padding-right: 0px; } }

.Header_rotateImg__NqaIl {
  padding-top: 5px;
  transform: rotate(180deg); }

.Header_header__OKWO7 {
  width: 100%;
  background-color: #275CE6;
  display: flex;
  flex-direction: column;
  justify-content: center; }

.Header_headertop__FP7ld {
  height: 80px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #5588F7; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_headertop__FP7ld {
      border-bottom: none;
      height: 0; } }

.Header_dttReports__7rb6L {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #FFFFFF;
  margin-left: 160px; }
  .Header_dttReports__7rb6L .Header_backArrow__-XUaz {
    width: 24px;
    height: 24px;
    padding-right: -10px; }
  .Header_dttReports__7rb6L .Header_ucubeText__pzBES {
    padding-bottom: 5px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_dttReports__7rb6L {
      display: none; } }

.Header_navlinks__lHaae, .Header_menuSide__jecxs {
  display: none;
  flex-direction: row;
  align-items: center;
  color: #FFFFFF;
  gap: 16px;
  margin-right: 180px;
  cursor: pointer; }
  .Header_navlinks__lHaae p, .Header_menuSide__jecxs p {
    font-size: 14px;
    font-weight: 400;
    margin-top: 12px !important; }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      .Header_navlinks__lHaae p, .Header_menuSide__jecxs p {
        margin-top: 0px !important; } }
  .Header_navlinks__lHaae span, .Header_menuSide__jecxs span {
    margin-left: 16px;
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer; }
    .Header_navlinks__lHaae span p, .Header_menuSide__jecxs span p {
      font-weight: 400;
      font-size: 14px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_navlinks__lHaae, .Header_menuSide__jecxs {
      position: absolute;
      left: -200%; }
      .Header_navlinks__lHaae p, .Header_menuSide__jecxs p {
        margin-top: 0 !important; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_menuSide__jecxs {
    position: fixed;
    left: 0;
    top: 150px;
    height: 100%;
    width: 100%;
    background-color: #FFFFFF;
    color: #000000;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 999; } }

.Header_headerbottom__8QzjO, .Header_headerSidebar__SnNhk {
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding-right: 170px;
  background-color: #275CE6;
  padding-bottom: 16px; }
  .Header_headerbottom__8QzjO p, .Header_headerSidebar__SnNhk p {
    margin-right: 10px;
    font-weight: 600;
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 5px !important; }
  .Header_headerbottom__8QzjO .Header_hamMenu__ohlUM, .Header_headerSidebar__SnNhk .Header_hamMenu__ohlUM {
    display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_headerbottom__8QzjO, .Header_headerSidebar__SnNhk {
      padding-right: 12px;
      padding-bottom: 0px; }
      .Header_headerbottom__8QzjO .Header_hamMenu__ohlUM, .Header_headerSidebar__SnNhk .Header_hamMenu__ohlUM {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        position: absolute;
        top: 22px;
        left: 16px; }
      .Header_headerbottom__8QzjO .Header_hamMenu__ohlUM div, .Header_headerSidebar__SnNhk .Header_hamMenu__ohlUM div {
        width: 20px;
        height: 2px;
        border-radius: 2px;
        background-color: #FFFFFF; }
      .Header_headerbottom__8QzjO p, .Header_headerSidebar__SnNhk p {
        margin-right: 16px;
        font-size: 14px; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_headerSidebar__SnNhk {
    position: relative;
    background-color: #275CE6;
    display: flex;
    flex-direction: column;
    height: 170px;
    width: 100%;
    justify-content: space-around; }
    .Header_headerSidebar__SnNhk div,
    .Header_headerSidebar__SnNhk p {
      width: 100%;
      display: flex; }
    .Header_headerSidebar__SnNhk .Header_hamMenu__ohlUM {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      margin-left: 0;
      position: absolute;
      top: 22px;
      right: 22px;
      left: initial; }
    .Header_headerSidebar__SnNhk p {
      display: none; } }

.Header_menuIcons__OJbLs {
  display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_menuIcons__OJbLs {
      display: block; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_menuSide__jecxs {
    border-radius: 24px 24px 0px 0px;
    padding-top: 32px; }
    .Header_menuSide__jecxs div,
    .Header_menuSide__jecxs span {
      display: flex;
      flex-direction: row;
      gap: 16px;
      height: 64px;
      align-items: center;
      text-align: center;
      margin-left: 16px; } }

.Header_logout__37eUY {
  margin-top: 10px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_logout__37eUY {
      display: none; } }

.Header_logout_blue__f69n1 {
  display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_logout_blue__f69n1 {
      display: block; } }

.Header_header1__l-h9n, .Header_noneHeader__WEcZN {
  background-color: #275ce6;
  height: 40px;
  font-size: 20px;
  color: #ffffff;
  font-weight: 900;
  /* margin-right: 180px; */
  position: relative;
  display: flex;
  justify-content: end;
  padding-right: 180px;
  padding-top: 10px !important; }
  .Header_header1__l-h9n img, .Header_noneHeader__WEcZN img {
    display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_header1__l-h9n, .Header_noneHeader__WEcZN {
      gap: 8px;
      font-size: 16px;
      padding-right: 24px;
      height: initial;
      padding-top: 22px !important; }
      .Header_header1__l-h9n img, .Header_noneHeader__WEcZN img {
        display: initial;
        margin-top: 8px; } }

.Header_underLine__NxieJ {
  text-decoration: underline; }

.Header_bsaDropdown__XquXj {
  border: none;
  background-color: #275CE6;
  color: #FFFFFF;
  overflow: hidden !important;
  outline: none;
  cursor: pointer; }
  .Header_bsaDropdown__XquXj option {
    cursor: pointer; }
  .Header_bsaDropdown__XquXj :focus {
    border: none; }
  .Header_bsaDropdown__XquXj :focus-within {
    border: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_bsaDropdown__XquXj {
      width: initial; }
      .Header_bsaDropdown__XquXj option {
        min-width: 40px; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_mobileViewAdjust__iO5re {
    background-color: #275CE6;
    padding-bottom: 10px; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_menuOpenView__q1Z2- {
    background-color: #275CE6;
    padding-bottom: 10px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_noneHeader__WEcZN {
    position: absolute;
    top: 60px;
    left: 16px;
    z-index: 10; }
    .Header_noneHeader__WEcZN img {
      display: none; } }

.Header_backArrow__-XUaz {
  width: 24px;
  height: 24px; }

:root {
  --rt-opacity: 1 !important; }

.Header_country_popup__WLtFa {
  margin-right: 180px;
  display: flex;
  flex-direction: row;
  gap: 16px; }
  .Header_country_popup__WLtFa .Header_countryName__A5z0F {
    border-right: 1px solid #5588f7;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-right: 16px; }
    .Header_country_popup__WLtFa .Header_countryName__A5z0F .Header_name__59-C5 {
      font-size: 20px !important;
      font-weight: 400 !important;
      margin-bottom: 5px !important;
      color: #FFFFFF; }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      .Header_country_popup__WLtFa .Header_countryName__A5z0F {
        border-right: 0px; } }
    .Header_country_popup__WLtFa .Header_countryName__A5z0F .Header_countryLogo__cqMBU {
      border-radius: 50%; }
  .Header_country_popup__WLtFa .Header_profileIcon__g\\+pXV {
    cursor: pointer; }
  .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ {
    background-color: #FFFFFF !important;
    border-radius: 8px !important;
    padding: 16px !important;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    z-index: 1; }
    .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A {
      width: 344px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      cursor: auto !important; }
      .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A .Header_popupDetails__8lf\\+y {
        padding: 18px 8px;
        width: 100%;
        border-radius: 8px;
        background-color: #F3F7FD;
        color: #333C43; }
        .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A .Header_popupDetails__8lf\\+y h4 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 8px;
          line-height: 120%; }
        .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A .Header_popupDetails__8lf\\+y p {
          font-size: 14px;
          font-weight: 400;
          line-height: 120%; }
        .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A .Header_popupDetails__8lf\\+y .Header_userDetailsPopup__J1iC5 {
          padding-top: 24px;
          display: flex;
          flex-direction: column;
          gap: 16px; }
        .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A .Header_popupDetails__8lf\\+y .Header_popup_role__Sb7xd {
          display: flex;
          flex-direction: row;
          gap: 8px;
          font-weight: 600; }
          .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A .Header_popupDetails__8lf\\+y .Header_popup_role__Sb7xd p {
            line-height: normal; }
          .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A .Header_popupDetails__8lf\\+y .Header_popup_role__Sb7xd .Header_popupDetails_bsaDropdown__bge5e {
            display: flex;
            gap: 6px;
            border-bottom: 1px solid #275CE6;
            background-color: #F3F7FD;
            color: #275CE6; }
      .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A .Header_popupLogout__vxlou {
        display: flex;
        flex-direction: row;
        padding: 10px;
        cursor: pointer;
        width: 100%; }
        .Header_country_popup__WLtFa .Header_popupModal__GMRC\\+ .Header_popup__Kdp\\+A .Header_popupLogout__vxlou p {
          color: #275CE6;
          font-weight: 600;
          font-size: 14px;
          padding-left: 8px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .Header_country_popup__WLtFa {
      display: none; } }

.Header_dropupdowntrue__Ouzcs {
  transform: rotate(180deg); }
`, "",{"version":3,"sources":["webpack://./src/assets/styles/_mixin.scss","webpack://./src/components/Header/Header.module.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,gCAAgC;EAChC,+DAA2D;EAC3D,mBAAmB;EACnB,kBAAkB,EAAA;;ACNpB;EACE,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAA;EALjB;IAOI,WAAW;IACX,YAAY,EAAA;EARhB;IAWI,gBAAgB;IAChB,eCyBsB;IDxBtB,cCdU;IDeV,gBAAgB,EAAA;EDGlB;ICjBF;MAiBI,aAAa,EAAA,EAEhB;;AAED;EACE,aAAa;EACb,eCSsB;EDRtB,gBAAgB;EAChB,mBAAmB,EAAA;EAJrB;IAMI,iBCKoB,EAAA;IDXxB;MAQM,gBCgBoB,EAAA;EF5BxB;ICIF;MAYI,aAAa;MAEb,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,WAAW,EAAA,EAEd;;ADzBC;EC2BF;IAGI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IAErB,UAAU;IACV,YAAY;IACZ,gBAAgB,EAAA,EAEnB;;AACD;EACE,kBAAkB;EAElB,uBAAuB,EAAA;EAHzB;IAKI,iBAAiB;IACjB,eC9BoB;ID+BpB,gBCpBoB,EAAA;EF1BtB;ICuCF;MAUI,YAAY;MACZ,UAAU,EAAA,EAEb;;AACD;EACE,iBAAiB,EAAA;EADnB;IAGI,kBAAkB,EAAA;EDxDpB;ICqDF;MAMI,aAAa;MACb,mBAAmB,EAAA;MAPvB;QASM,kBAAkB,EAAA,EACnB;;AAuBL;EACE,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;EACE,WAAW;EACX,yBCjHkB;EDkHlB,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAA;;AAEzB;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCC5HmB,EAAA;EFmBnB;ICkGF;MASI,mBAAmB;MACnB,SAAS,EAAA,EAEZ;;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cCrIY;EDsIZ,kBAAkB,EAAA;EALpB;IAOI,WAAW;IACX,YAAY;IACZ,oBAAoB,EAAA;EATxB;IAYI,mBAAmB,EAAA;ED3HrB;IC+GF;MAeI,aAAa,EAAA,EAEhB;;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cCvJY;EDwJZ,SAAS;EACT,mBAAmB;EACnB,eAAe,EAAA;EAPjB;IASI,eC3HoB;ID4HpB,gBCjHoB;IDkHpB,2BAA2B,EAAA;ID5I7B;MCiIF;QAaM,0BAA0B,EAAA,EAE7B;EAfH;IAiBI,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,mBAAmB;IAEnB,eAAe,EAAA;IAtBnB;MAwBM,gBC/HkB;MDgIlB,eC3IkB,EAAA;EFftB;ICiIF;MA8BI,kBAAkB;MAClB,WAAW,EAAA;MA/Bf;QAiCM,wBAAwB,EAAA,EACzB;;ADnKH;ECsKF;IAGI,eAAe;IACf,OAAO;IACP,UAAU;IACV,YAAY;IACZ,WAAW;IACX,yBChMU;IDiMV,cC1LU;ID2LV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY,EAAA,EAEf;;AACD;EACE,WAAW;EAEX,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,yBCjNkB;EDkNlB,oBAAoB,EAAA;EARtB;IAUI,kBAAkB;IAClB,gBCrKsB;IDsKtB,eCnLoB;IDoLpB,cCrNU;IDsNV,6BAA6B,EAAA;EAdjC;IAiBI,aAAa,EAAA;EDvMf;ICsLF;MAsBI,mBAAmB;MACnB,mBAAmB,EAAA;MAvBvB;QAyBM,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;QACR,kBAAkB;QAClB,SAAS;QACT,UAAU,EAAA;MAhChB;QAmCM,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,yBC9OQ,EAAA;MDwMd;QAyCM,kBAAkB;QAClB,eCjNkB,EAAA,EDkNnB;;ADjOH;ECoOF;IAGI,kBAAkB;IAClB,yBC5PgB;ID6PhB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,6BAA6B,EAAA;IATjC;;MAYM,WAAW;MACX,aAAa,EAAA;IAbnB;MAgBM,aAAa;MACb,yBAAyB;MACzB,qBAAqB;MACrB,cAAc;MACd,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,aAAa,EAAA;IAvBnB;MA0BM,aAAa,EAAA,EACd;;AAGL;EACE,aAAa,EAAA;EDnQb;ICkQF;MAGI,cAAc,EAAA,EAEjB;;ADvQC;ECsKF;IAoGI,gCAAgC;IAChC,iBAAiB,EAAA;IAHrB;;MAMM,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,YAAY;MACZ,mBAAmB;MACnB,kBAAkB;MAClB,iBAAiB,EAAA,EAClB;;AAGL;EACE,gBAAgB,EAAA;EDzRhB;ICwRF;MAGI,aAAa,EAAA,EAEhB;;AACD;EACE,aAAa,EAAA;ED/Rb;IC8RF;MAGI,cAAc,EAAA,EAEjB;;AAED;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAA;EACA,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,4BAA4B,EAAA;EAX9B;IAaI,aAAa,EAAA;EDlTf;ICqSF;MAiBI,QAAQ;MACR,eAAe;MACf,mBAAmB;MACnB,eAAe;MACf,4BAA4B,EAAA;MArBhC;QAuBM,gBAAgB;QAChB,eAAe,EAAA,EAChB;;AAIL;EACE,0BAA0B,EAAA;;AAE5B;EACE,YAAY;EACZ,yBC3VkB;ED4VlB,cC1VY;ED2VZ,2BAA2B;EAC3B,aAAa;EACb,eAAe,EAAA;EANjB;IAUI,eAAe,EAAA;EAVnB;IAaI,YAAY,EAAA;EAbhB;IAgBI,YAAY,EAAA;EDrVd;ICqUF;MAmBI,cAAc,EAAA;MAnBlB;QAqBM,eAAe,EAAA,EAChB;;AD3VH;EC8VF;IAEI,yBCpXgB;IDqXhB,oBAAoB,EAAA,EAEvB;;ADnWC;ECoWF;IAEI,yBC1XgB;ID2XhB,oBAAoB;IACpB,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW,EAAA,EAEd;;AD9WC;EC+WF;IAGI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW,EAAA;IANf;MAQM,aAAa,EAAA,EACd;;AAGL;EACE,WAAW;EACX,YAAY,EAAA;;AAEd;EACE,0BAAa,EAAA;;AAEf;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAA;EAJX;IAMI,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB,EAAA;IAVvB;MAYM,0BAA0B;MAC1B,2BAA2B;MAC3B,6BAA6B;MAC7B,cCnaQ,EAAA;IFkBZ;MCkYF;QAmBM,iBAAiB,EAAA,EAMpB;IAzBH;MAuBM,kBAAkB,EAAA;EAvBxB;IA2BI,eAAe,EAAA;EA3BnB;IA8BI,oCAAmC;IACnC,6BAA6B;IAC7B,wBAAwB;IACxB,+CAA+C;IAC/C,UAAU,EAAA;IAlCd;MAoCM,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,uBAAuB,EAAA;MAxC7B;QA0CQ,iBAAiB;QACjB,WAAW;QACX,kBAAkB;QAClB,yBCzbgB;QD0bhB,cCpba,EAAA;QDsYrB;UAgDU,eChamB;UDianB,gBCvZgB;UDwZhB,kBAAkB;UAClB,iBAAiB,EAAA;QAnD3B;UAsDU,eCzac;UD0ad,gBC/Zc;UDgad,iBAAiB,EAAA;QAxD3B;UA2DU,iBAAiB;UACjB,aAAa;UACb,sBAAsB;UACtB,SAAS,EAAA;QA9DnB;UAiEU,aAAa;UACb,mBAAmB;UACnB,QAAQ;UACR,gBC1agB,EAAA;UDsW1B;YAsEY,mBAAmB,EAAA;UAtE/B;YAyEY,aAAa;YACb,QAAQ;YACR,gCCjeQ;YDkeR,yBCxdY;YDydZ,cCneQ,EAAA;MDsZpB;QAkFQ,aAAa;QACb,mBAAmB;QACnB,aAAa;QACb,eAAe;QACf,WAAW,EAAA;QAtFnB;UAwFU,cC9eU;UD+eV,gBC/bgB;UDgchB,eC7cc;UD8cd,iBAAiB,EAAA;ED7dzB;ICkYF;MAiGI,aAAa,EAAA,EAEhB;;AACD;EACE,yBAAyB,EAAA","sourcesContent":["@import \"./variables\";\n\n// Font family\n\n@font-face {\n  font-family: \"Unilever Shilling\";\n  src: url(\"../fonts/UnileverShilling.ttf\")format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n\n// Font families and font-weights\n\n@mixin volteMedium {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin volteSemibold {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin sm {\n  @media only screen and (min-width: 320px) and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media only screen and (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm-min {\n  @media only screen and (min-width: 992px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media only screen and (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl-min {\n  @media only screen and (min-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media only screen and (min-width: 1280px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media only screen and (min-width: 1440px) {\n    @content;\n  }\n}\n\n@mixin sm-tab {\n  @media only screen and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin ipad {\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    @content;\n  }\n}\n\n","@import \"../../assets/styles/variables\";\n@import \"../../assets/styles/mixin\";\n* {\n  margin: 0;\n}\n\n.headerLogo {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 0;\n  img {\n    width: 48px;\n    height: 48px;\n  }\n  p {\n    font-weight: 600;\n    font-size: $font-size-lg-medium;\n    color: $white;\n    padding-top: 8px;\n  }\n  @include sm {\n    display: none;\n  }\n}\n\n.details {\n  display: none;\n  font-size: $font-size-sm-base;\n  padding-top: 2px;\n  padding-left: 350px;\n  p {\n    font-weight: $font-size-sm-base;\n    span {\n      font-weight: $font-weight-semibold;\n    }\n  }\n  @include sm {\n    display: none;\n    // display: flex;\n    padding-left: 0px;\n    flex-direction: column;\n    align-items: end;\n    text-align: end;\n    padding-top: 30px;\n    height: 0px;\n  }\n}\n\n.dropDown {\n  @extend .details;\n  @include sm {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    // margin-right: 25px;\n    padding: 0;\n    height: 60px;\n    padding-top: 8px;\n  }\n}\n.detailsRole {\n  padding-right: 8px;\n  // margin-top: 5px;\n  border-right: 1px solid;\n  b {\n    padding-left: 6px;\n    font-size: $font-size-sm-base;\n    font-weight: $font-weight-normal;\n  }\n  @include sm {\n    border: none;\n    padding: 0;\n  }\n}\n.assignment {\n  padding-left: 8px;\n  span {\n    padding-right: 6px;\n  }\n  @include sm {\n    display: flex;\n    flex-direction: row;\n    span {\n      padding-right: 0px;\n    }\n  }\n}\n// .greeting{\n//     font-size: $font-size-md-xtraLarge;\n//     font-weight: $font-weight-bold;\n//     line-height: 120%;\n//     display: flex;\n//     img{\n//         display: none;\n//     }\n//     @include sm{\n//         gap: 12px;\n//         img{\n//             display: inline-block;\n//             width: 13px;\n//             height: 13px;\n//             cursor: pointer;\n//             padding-top: 5px;\n//             transition: 0.3s ease;\n//         }\n//     }\n// }\n.rotateImg {\n  padding-top: 5px;\n  transform: rotate(180deg);\n}\n\n.header {\n  width: 100%;\n  background-color: $primaryBlue;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.headertop {\n  height: 80px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid $secondryBlue;\n  @include sm {\n    border-bottom: none;\n    height: 0;\n  }\n}\n.dttReports {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: $white;\n  margin-left: 160px;\n  .backArrow {\n    width: 24px;\n    height: 24px;\n    padding-right: -10px;\n  }\n  .ucubeText {\n    padding-bottom: 5px;\n  }\n  @include sm {\n    display: none;\n  }\n}\n.navlinks {\n  display: none;\n  flex-direction: row;\n  align-items: center;\n  color: $white;\n  gap: 16px;\n  margin-right: 180px;\n  cursor: pointer;\n  p {\n    font-size: $font-size-sm-base;\n    font-weight: $font-weight-normal;\n    margin-top: 12px !important;\n    @include sm {\n      margin-top: 0px !important;\n    }\n  }\n  span {\n    margin-left: 16px;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    // margin-bottom: 10px;\n    cursor: pointer;\n    p {\n      font-weight: $font-weight-normal;\n      font-size: $font-size-sm-base;\n      // margin-top: 12px !important;\n    }\n  }\n  @include sm {\n    position: absolute;\n    left: -200%;\n    p {\n      margin-top: 0 !important;\n    }\n  }\n}\n.menuSide {\n  @extend .navlinks;\n  @include sm {\n    position: fixed;\n    left: 0;\n    top: 150px;\n    height: 100%;\n    width: 100%;\n    background-color: $white;\n    color: $black;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    z-index: 999;\n  }\n}\n.headerbottom {\n  width: 100%;\n  // height: 30px;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding-right: 170px;\n  background-color: $primaryBlue;\n  padding-bottom: 16px;\n  p {\n    margin-right: 10px;\n    font-weight: $font-weight-semibold;\n    font-size: $font-size-sm-base;\n    color: $white;\n    margin-bottom: 5px !important;\n  }\n  .hamMenu {\n    display: none;\n  }\n  @include sm {\n    // height: 60px;\n    // justify-content: space-between;\n    padding-right: 12px;\n    padding-bottom: 0px;\n    .hamMenu {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n      position: absolute;\n      top: 22px;\n      left: 16px;\n    }\n    .hamMenu div {\n      width: 20px;\n      height: 2px;\n      border-radius: 2px;\n      background-color: $white;\n    }\n    p {\n      margin-right: 16px;\n      font-size: $font-size-sm-base;\n    }\n  }\n}\n.headerSidebar {\n  @extend .headerbottom;\n  @include sm {\n    position: relative;\n    background-color: $primaryBlue;\n    display: flex;\n    flex-direction: column;\n    height: 170px;\n    width: 100%;\n    justify-content: space-around;\n    div,\n    p {\n      width: 100%;\n      display: flex;\n    }\n    .hamMenu {\n      display: flex;\n      justify-content: flex-end;\n      align-items: flex-end;\n      margin-left: 0;\n      position: absolute;\n      top: 22px;\n      right: 22px;\n      left: initial;\n    }\n    p {\n      display: none;\n    }\n  }\n}\n.menuIcons {\n  display: none;\n  @include sm {\n    display: block;\n  }\n}\n.menuSide {\n  @include sm {\n    border-radius: 24px 24px 0px 0px;\n    padding-top: 32px;\n    div,\n    span {\n      display: flex;\n      flex-direction: row;\n      gap: 16px;\n      height: 64px;\n      align-items: center;\n      text-align: center;\n      margin-left: 16px;\n    }\n  }\n}\n.logout {\n  margin-top: 10px;\n  @include sm {\n    display: none;\n  }\n}\n.logout_blue {\n  display: none;\n  @include sm {\n    display: block;\n  }\n}\n\n.header1 {\n  background-color: #275ce6;\n  height: 40px;\n  font-size: 20px;\n  color: #ffffff;\n  font-weight: 900;\n  /* margin-right: 180px; */\n  position: relative;\n  display: flex;\n  justify-content: end;\n  padding-right: 180px;\n  padding-top: 10px !important;\n  img {\n    display: none;\n  }\n  @include sm {\n    // display: none;\n    gap: 8px;\n    font-size: 16px;\n    padding-right: 24px;\n    height: initial;\n    padding-top: 22px !important;\n    img {\n      display: initial;\n      margin-top: 8px;\n    }\n  }\n}\n\n.underLine {\n  text-decoration: underline;\n}\n.bsaDropdown {\n  border: none;\n  background-color: $primaryBlue;\n  color: $white;\n  overflow: hidden !important;\n  outline: none;\n  cursor: pointer;\n  // width: initial;\n  option {\n    // min-width: 80px;\n    cursor: pointer;\n  }\n  :focus {\n    border: none;\n  }\n  :focus-within {\n    border: none;\n  }\n  @include sm {\n    width: initial;\n    option {\n      min-width: 40px;\n    }\n  }\n}\n.mobileViewAdjust {\n  @include sm {\n    background-color: $primaryBlue;\n    padding-bottom: 10px;\n  }\n}\n.menuOpenView {\n  @include sm {\n    background-color: $primaryBlue;\n    padding-bottom: 10px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 99;\n  }\n}\n.noneHeader {\n  @extend .header1;\n  @include sm {\n    position: absolute;\n    top: 60px;\n    left: 16px;\n    z-index: 10;\n    img {\n      display: none;\n    }\n  }\n}\n.backArrow {\n  width: 24px;\n  height: 24px;\n}\n:root {\n  --rt-opacity: 1 !important;\n}\n.country_popup {\n  margin-right: 180px;\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  .countryName {\n    border-right: 1px solid #5588f7;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding-right: 16px;\n    .name {\n      font-size: 20px !important;\n      font-weight: 400 !important;\n      margin-bottom: 5px !important;\n      color: $white;\n    }\n\n    @include sm {\n      border-right: 0px;\n    }\n    .countryLogo {\n      // border: 1px solid white;\n      border-radius: 50%;\n    }\n  }\n  .profileIcon {\n    cursor: pointer;\n  }\n  .popupModal {\n    background-color: $white !important;\n    border-radius: 8px !important;\n    padding: 16px !important;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n    z-index: 1;\n    .popup {\n      width: 344px;\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n      cursor: auto !important;\n      .popupDetails {\n        padding: 18px 8px;\n        width: 100%;\n        border-radius: 8px;\n        background-color: $timedetailsGrey;\n        color: $darkGreyText;\n        h4 {\n          font-size: $font-size-md-xtraLarge;\n          font-weight: $font-weight-semibold;\n          margin-bottom: 8px;\n          line-height: 120%;\n        }\n        p {\n          font-size: $font-size-sm-base;\n          font-weight: $font-weight-normal;\n          line-height: 120%;\n        }\n        .userDetailsPopup {\n          padding-top: 24px;\n          display: flex;\n          flex-direction: column;\n          gap: 16px;\n        }\n        .popup_role {\n          display: flex;\n          flex-direction: row;\n          gap: 8px;\n          font-weight: $font-weight-semibold;\n          p {\n            line-height: normal;\n          }\n          .popupDetails_bsaDropdown {\n            display: flex;\n            gap: 6px;\n            border-bottom: 1px solid $primaryBlue;\n            background-color: $timedetailsGrey;\n            color: $primaryBlue;\n          }\n        }\n      }\n      .popupLogout {\n        display: flex;\n        flex-direction: row;\n        padding: 10px;\n        cursor: pointer;\n        width: 100%;\n        p {\n          color: $primaryBlue;\n          font-weight: $font-weight-semibold;\n          font-size: $font-size-sm-base;\n          padding-left: 8px;\n        }\n      }\n    }\n  }\n  @include sm {\n    display: none;\n  }\n}\n.dropupdowntrue {\n  transform: rotate(180deg);\n}\n","// Color codes here.\n$headerBlue:#275CE6;\n$headerBorder:#5588F7;\n$primaryBlue:#275CE6;\n$secondryBlue:#5588F7;\n$white:#FFFFFF;\n$tertiaryGrey:#676E72;\n$errorRed: #D52F3D;\n$progressRed:#E43263;\n$errorRed: #D52F3D;\n$progressGreen:#59B876;\n$progressCircleGrey:#9496A0;\n$black:#000000;\n$timedetailsGrey:#F3F7FD;\n$buttonbgBlue:#5588F7;\n$inputBorder:#CCCFD0;\n$buttonDisableBg:#E5E6E7;\n$buttonDisableText:#999EA1;\n$errorMessageRed:#FF5C83;\n$darkGreyText:#333C43;\n$tableHeader:#F6FCFF;\n$LandingPageBlue:#1E49B9;\n$secondary_lightish:#E1ECF5;\n$opTabViewDisabled:#F2F3F3;\n$otpGreyText:#B3B6C5;\n$otpErrorRed:#D52F3D;\n$oddTableRow: #f8f9fc;\n$agTableRow: #f3f3f3;\n$scrollbar: #888;\n$scrollbarHover: #555;\n$scrollbarTrack: #f1f1f1;\n$dropdownListColor: #f0f0f0;\n$dropdownShadow: #6123E70F;\n$disableButton : #cccccc;\n$progressContainer: #e0e0e0;\n// Font Sizes\n$font-size-xs-small: 10px;\n$font-size-sm-small: 12px;\n$font-size-sm-base: 14px;\n$font-size-md-medium: 16px;\n$font-size-md-large: 18px;\n$font-size-md-xtraLarge: 20px;\n$font-size-md-xLarge: 22px;\n$font-size-lg-medium: 24px;\n$font-size-xl-large: 32px;\n$font-size-xl-xtraLarge: 40px;\n$font-size-xl-medium: 28px;\n\n// Font weights\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n// Font Styles\n$font-style: 'Unilever Shilling';\n\n// Line Height\n$line-height-medium: 16px;\n\n// Spacing\n$spacing-zero: 0px;\n$spacing-xs: 10px;\n$spacing-sm: 12px;\n$spacing-sm-m: 14px;\n$spacing-md: 16px;\n$spacing-md-m: 18px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerLogo": `Header_headerLogo__xZ0F4`,
	"details": `Header_details__2H5g0`,
	"dropDown": `Header_dropDown__6bSwA`,
	"detailsRole": `Header_detailsRole__o4gqo`,
	"assignment": `Header_assignment__sOzLF`,
	"rotateImg": `Header_rotateImg__NqaIl`,
	"header": `Header_header__OKWO7`,
	"headertop": `Header_headertop__FP7ld`,
	"dttReports": `Header_dttReports__7rb6L`,
	"backArrow": `Header_backArrow__-XUaz`,
	"ucubeText": `Header_ucubeText__pzBES`,
	"navlinks": `Header_navlinks__lHaae`,
	"menuSide": `Header_menuSide__jecxs`,
	"headerbottom": `Header_headerbottom__8QzjO`,
	"headerSidebar": `Header_headerSidebar__SnNhk`,
	"hamMenu": `Header_hamMenu__ohlUM`,
	"menuIcons": `Header_menuIcons__OJbLs`,
	"logout": `Header_logout__37eUY`,
	"logout_blue": `Header_logout_blue__f69n1`,
	"header1": `Header_header1__l-h9n`,
	"noneHeader": `Header_noneHeader__WEcZN`,
	"underLine": `Header_underLine__NxieJ`,
	"bsaDropdown": `Header_bsaDropdown__XquXj`,
	"mobileViewAdjust": `Header_mobileViewAdjust__iO5re`,
	"menuOpenView": `Header_menuOpenView__q1Z2-`,
	"country_popup": `Header_country_popup__WLtFa`,
	"countryName": `Header_countryName__A5z0F`,
	"name": `Header_name__59-C5`,
	"countryLogo": `Header_countryLogo__cqMBU`,
	"profileIcon": `Header_profileIcon__g+pXV`,
	"popupModal": `Header_popupModal__GMRC+`,
	"popup": `Header_popup__Kdp+A`,
	"popupDetails": `Header_popupDetails__8lf+y`,
	"userDetailsPopup": `Header_userDetailsPopup__J1iC5`,
	"popup_role": `Header_popup_role__Sb7xd`,
	"popupDetails_bsaDropdown": `Header_popupDetails_bsaDropdown__bge5e`,
	"popupLogout": `Header_popupLogout__vxlou`,
	"dropupdowntrue": `Header_dropupdowntrue__Ouzcs`
};
export default ___CSS_LOADER_EXPORT___;
